const BotIcon = () => (
  <svg
    width="107"
    height="107"
    viewBox="0 0 107 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M97.7653 51.7453C96.8647 49.5696 94.9342 49.048 93.6279 48.9231V35.6641C93.6279 30.7465 89.6288 26.7474 84.7113 26.7474H57.9613V20.5503C59.321 19.3287 60.1904 17.5721 60.1904 15.6016C60.1904 13.8279 59.4858 12.1269 58.2317 10.8728C56.9775 9.61864 55.2766 8.91406 53.5029 8.91406C51.7293 8.91406 50.0283 9.61864 48.7741 10.8728C47.52 12.1269 46.8154 13.8279 46.8154 15.6016C46.8154 17.5721 47.6848 19.3287 49.0446 20.5503V26.7474H22.2946C17.377 26.7474 13.3779 30.7465 13.3779 35.6641V49.0257L13.0123 49.0524C11.8887 49.1335 10.8375 49.637 10.0699 50.4616C9.30237 51.2862 8.87546 52.3708 8.875 53.4974V62.4141C8.875 63.5965 9.34472 64.7305 10.1808 65.5666C11.0169 66.4027 12.1509 66.8724 13.3333 66.8724H13.3779V89.1641C13.3779 94.0816 17.377 98.0807 22.2946 98.0807H84.7113C89.6288 98.0807 93.6279 94.0816 93.6279 89.1641V66.8724C94.8103 66.8724 95.9443 66.4027 96.7804 65.5666C97.6165 64.7305 98.0863 63.5965 98.0863 62.4141V53.7738C98.1376 53.0819 98.0277 52.3875 97.7653 51.7453ZM22.2946 89.1641V35.6641H84.7113L84.7157 53.4796L84.7113 53.4974V62.4141L84.7157 62.4364L84.7202 89.1641H22.2946Z"
      fill="currentColor"
    />
    <path
      d="M37.8984 62.4193C41.5918 62.4193 44.5859 58.4271 44.5859 53.5026C44.5859 48.5781 41.5918 44.5859 37.8984 44.5859C34.205 44.5859 31.2109 48.5781 31.2109 53.5026C31.2109 58.4271 34.205 62.4193 37.8984 62.4193Z"
      fill="currentColor"
    />
    <path
      d="M69.1016 62.4193C72.795 62.4193 75.7891 58.4271 75.7891 53.5026C75.7891 48.5781 72.795 44.5859 69.1016 44.5859C65.4082 44.5859 62.4141 48.5781 62.4141 53.5026C62.4141 58.4271 65.4082 62.4193 69.1016 62.4193Z"
      fill="currentColor"
    />
    <path
      d="M35.6641 71.3359H71.3307V80.2526H35.6641V71.3359Z"
      fill="currentColor"
    />
  </svg>
)
export default BotIcon
